export const adminRouteNames = [
  'adminOpportunities', 'adminOpportunity', 'adminOpportunityCreate', 'adminOpportunityDuplicate',
  'adminOpportunityTemplates', 'adminOpportunityTemplateForm', 'adminOpportunityTemplateFormEdit',
  'adminOpportunityRequests', 'adminOpportunityChangeRequests', 'adminOpportunityPhotos',
  'adminCommunications', 'adminMetrics', 'adminNonprofits', 'adminNonprofit',
]
